<script>
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
export default {
  mixins: [Api, Sabit],
  props: ["Id"],
  page: {
    title: "İyileştirme Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
  },
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {}, 
    };
  },
  watch: {
    Id() {
      if (this.Id) {
        this.FilterGet()
      }
    },
  },
  methods: {
    Get() { this.FilterGet() },
    FilterGet() {

      if (this.Id) {
        this.ActionsFilterGet({ Service: "StrIsoIzlemKriterleriBirim", Page: this.Page, Filter: "&Onay=true&Kriterid=" + this.Id }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });
      }
    },

  },
};
</script>


<template>


  <Loader>
    <b-modal id="Rapor" size="xl" title="İzleme Kriterleri Raporu" title-class="font-18" hide-footer>
      <div class="col-sm-12 ">
                  <div class="text-sm-end">   <b-dropdown variant="success" class="btn  btn-rounded mb-2 me-2">
            <template v-slot:button-content>
              <i class="mdi mdi-file-export-outline me-1"></i>Yazdır <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIzlemKriterleriBirim/print/BirimDurum', DowlandName: 'İzleme Kriterleri Raporu', FileName: 'StrIsoIzlemKriterleriBirim', FileFormat: 'xlsx', Filter: '&Onay=true&Kriterid=' + Id })">Excel</b-dropdown-item>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIzlemKriterleriBirim/print/BirimDurum', DowlandName: 'İzleme Kriterleri Raporu', FileName: 'StrIsoIzlemKriterleriBirim', FileFormat: 'pdf', Filter: '&Onay=true&Kriterid=' + Id  })">Pdf</b-dropdown-item>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIzlemKriterleriBirim/print/BirimDurum', DowlandName: 'İzleme Kriterleri Raporu', FileName: 'StrIsoIzlemKriterleriBirim', FileFormat: 'docx', Filter: '&Onay=true&Kriterid=' + Id  })">Word</b-dropdown-item>
          </b-dropdown>
                  </div>
                </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Süreç</th>
              <th>Sorumlu Birim</th>
              <th>İzleme Kriteri No</th>
              <th>İzleme Kriteri</th>
              <th>Veri</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="Data in TableData" :key="Data.Id">
              <th scope="row">{{ Data.Surec }}</th>
              <td>{{ Data.Birim }}</td>
              <td>{{ Data.No }}</td>
              <td>{{ Data.Kriter }} </td>
              <td>{{ Data.Veri }}</td>

            </tr>
          </tbody>
        </table>
        <br />
        <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
          :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
          @input="ChangePage(DefaultPage)"> </b-pagination>
      </div>

    </b-modal>
  </Loader>
</template>
